import OrderItemPrice from './order_item_price';

export default OrderItemPrice;
